import {  Label, Save, Send } from "@mui/icons-material";
import dayjs from '../../utils/dayjs-setup';
import { Button, GridLegacy as Grid, IconButton, Input, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField } from '@mui/material';
import { useState, useEffect, useContext, useMemo } from "react";
import { AutoCompleteInputWithLabel, DatePickerInputWithLabel,  SelectInputWithLabel } from "../../components/form/custom-imputs";
import { ActionTypes, AppContext, FilterNecesidadesInit } from "../../store/AppStore";
import { AxiosInstance, CalculateInputsColNecesidades, DateFormatString, FormatPrice, ParseStateNecesidad } from "../../utils/constants";
import * as yup from "yup";
import {  SubItemTableNecesidades } from "../../components/table/table-components";
import { FilterForm } from "../../components/form/filter-form";
import { useNavigate } from "react-router-dom";
import { AppERoutesIndex } from "../../route/app-routes";
import { NecesidadTypes } from "../../utils/constants";

const HeaderRenderCustom = ({value,...props})=>{

  return  <Table border={1} >
     <TableHead  >
        <TableRow>
          {props.colsDetalle.map( col=> <TableCell sx={{width:'120px'}} key={col.cod} >
          {col.nombre}
           
           </TableCell>
           
           )}
        </TableRow>
        <TableRow>
          {props.colsDetalle.map( col=> <TableCell sx={{width:'120px'}} key={col.cod} >
            <Table  border={1} >
              <TableBody>
                  <TableRow>
                      <TableCell sx={{width:'110px'}} >Cantidad en Kg/Und</TableCell>
                      <TableCell sx={{width:'110px'}} >Cantidad en Unidad de cotización</TableCell>
                  </TableRow>
              </TableBody>
            </Table>
           
           </TableCell>
           
           )}
        </TableRow>
       
     </TableHead>
  </Table>

}




const schema = yup.object({
  municipio_origen: yup.object().required(),
  municipio_destino: yup.object().required(),
 }).required();


 const schemaFilter = yup.object({
  

 }).required();


const tableSizeSaveKey = "Necesidades-tableSizeSaveKey";

export const Necesidades = (props) => {

  const [dataSetProdctos, setDataSetProductos] = useState([]);
  const { dispatch, store } = useContext(AppContext);
  const {filterNecesidades} = store;
  const [totalRows, setTotalRows] = useState(0);
  const [productOptions,setProductOptions] = useState([]);
  const navigation = useNavigate();
  const [tableSize,setTableSize] = useState(localStorage.getItem(tableSizeSaveKey) || 450 );


  const saveScreenSize = ()=>{
    localStorage.setItem(tableSizeSaveKey,tableSize);
  }

  useEffect(() => {

    if ( filterNecesidades?.tipo_necesidad != NecesidadTypes.PROPIA ){
      let init = {...FilterNecesidadesInit,tipo_necesidad:NecesidadTypes.PROPIA};
      dispatch({
        type:ActionTypes.setFilterNecesidades,
        data:init
      });
      loadItems(init);
    }else{
      loadItems();
    }
   
   

  }, []);


  const  setFilterAply = (filtros)=>{
    console.log({filtros});
    dispatch({
      type:ActionTypes.setFilterNecesidades,
      data:{...FilterNecesidadesInit,
        necesidad_cubierta:filtros.necesidad_cubierta,
        producto:filtros?.product_select,
        fecha:dayjs(filtros.fecha_entrega).isValid()? dayjs(filtros.fecha_entrega).format(DateFormatString):null
      }
    });

    loadItems(true,{
      ...FilterNecesidadesInit,
      necesidad_cubierta:filtros.necesidad_cubierta,
      producto:filtros.product_select?.value,
      fecha:dayjs(filtros.fecha_entrega).isValid()? dayjs(filtros.fecha_entrega).format(DateFormatString):null
    });
  }


  const loadItems = async (loading = true,filter={...filterNecesidades}) => {
    console.log("filter n",filter);
    setDataSetProductos([]);
    if (loading) {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: true
      });
    }

    try {
      let { data: { value:{list,total_rows} } } = await AxiosInstance.post("necesidades/obtener-listado-necesidades", {
        filter:{
          ...filter,
          producto:filter.producto?.value || filter.producto,
          necesidad_cubierta:ParseStateNecesidad[String(filter.necesidad_cubierta)],
          tipo_necesidad:NecesidadTypes.PROPIA
        },
       
      });

      if ( productOptions?.length ===  0 ){
        let Options = [];
        list.forEach(prod=>{
            if ( !Options.find( op=>op.value === prod.cod_producto ) ){
                Options.push({label:prod.nombre_producto,value:prod.cod_producto});
            }
        });
       // setProductOptions([...Options]);
      }

      setDataSetProductos([...list]);

      setTotalRows(total_rows);
    } finally {
      dispatch({
        type: ActionTypes.setLoadingPage,
        data: false
      });
    }

  }


  const handleChangePage = (event, newPage) => {

    dispatch({
      type:ActionTypes.setFilterNecesidades,
      data:{...filterNecesidades,
        page_number: newPage 
      }
    });
  
    loadItems(true,{ ...filterNecesidades, page_number: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    dispatch({
      type:ActionTypes.setFilterNecesidades,
      data:{...filterNecesidades,
        rows_per_page: parseInt(event.target.value, 10)
      }
    });
  
    loadItems(true,{ ...filterNecesidades, rows_per_page: parseInt(event.target.value, 10),page_number:0 });
  };




  const onSearchProducto = async (value_search) => {

    if (value_search) {
       try{

        const { data: { value } } = await AxiosInstance.post("maestros/get-producto-filter?asigned=true", {
          search_query: value_search
        });
        return value;
       }catch(e){
        return [];
       }

    }



  }

  const searcProductoAsociado = async (event, newInputValue) => {
    try {
      let res = await onSearchProducto(newInputValue);
      setProductOptions(res);
    } catch (e) {

    }
  }

const {colsDetalle,NewDataMapped} = useMemo(
  () => CalculateInputsColNecesidades(dataSetProdctos),
  [dataSetProdctos]
);



const goToCotizar = (item)=>{
  console.log({item});
  navigation(AppERoutesIndex.comprasProductos
  .replace(":cod_producto",item.cod_producto)
  .replace(":fecha_entrega",item.fecha_entrega)
  .replace(":cod_unidad_medida",item.cod_unidad_medida)
  );
}


const columnsTable = [
  {

    key: "nombre_producto",
    keyValue: "nombre_producto",
    label: "Producto",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

  {

    key: "nombre_um_inv_prod",
    keyValue: "nombre_um_inv_prod",
    label: "Un. Inventario KG/UND",
    headerRender: (props) => props.label,
    bodyRender: (props) => `${props.value}`,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "conversion_peso",
    keyValue: "conversion_peso",
    label: "Kilos por un. de embalaje",
    headerRender: (props) => props.label,
    bodyRender: (props) => props.value,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "conversion_unidad_medida",
    keyValue: "conversion_unidad_medida",
    label: "Unidad de medida",
    headerRender: (props) => props.label,
    bodyRender: (props) => props.value,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "fecha_entrega",
    keyValue: "fecha_entrega",
    label: "fecha puesta en tienda",
    headerRender: (props) => props.label,
    bodyRender: (props) =>props.value,
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
  {

    key: "tipos_sobre_costos",
    keyValue: "total_items",
    colsDetalle:colsDetalle,
    label: "Sobrecostos",

    headerRender: (props) =><HeaderRenderCustom {...props} />,
    bodyRender: (props) => <SubItemTableNecesidades
     removeHeader={true}
      cols={[{
        label: "Tipo",
        valueKey: "valueUMI",
        keyRow: "cod",
        format:FormatPrice
       
      },
      {
        label: "Valor",
        valueKey: "valueUME",
        keyRow: "cod",
        format:FormatPrice
       
      }
      ]}
      typeView="horizontal"
      items={props.value} />,
    typeRow: "string",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },

  {
    key: "registro_unico_erp",
    keyValue: "registro_unico_erp",
    label: "Accion",
    headerRender: (props) => props.label,
    bodyRender: ({ value,item }) => <Button onClick={e => goToCotizar(item)} variant="contained" startIcon={<Send />} >Ir a comprar</Button>,
    typeRow: "number",
    sort: false,
    sortFunction: () => { },
    sortStatus: "",

  },
];

const InputFilters = [
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:AutoCompleteInputWithLabel,
  keyValue:"product_select",
  InputComponentProps:{
    label:"Producto",
    fullWidth: true,
    isLoading: false,
    multiple:false,
    size:'small',
/*     PopperComponent:(props)=><div hidden={!props.open} >
     
       {props.children}
    </div>, */
    onInputChange: searcProductoAsociado,
    options: productOptions || [],
    noOptionsText: "Lista vacia",
    getOptionLabel: (option) => option.label,
    isOptionEqualToValue: (option, value) => option.value === value.value,
    filterOptions:(x) => x,
  }
},
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:DatePickerInputWithLabel,
  keyValue:"fecha_entrega",
  inputProps:{
    size:'small',
  },
  InputComponentProps:{
    label:"Fecha de entrega",
    fullWidth:true,
    isLoading:false,
    inputFormat:"DD-MM-YYYY",
    value:null,
    size:'small',
    //onInputChange:searchMunicipiosOrigen,
   
  }
},
{
  grid:{
    xs:3,
    md:3,
    sm:3
  },
  InputComponent:SelectInputWithLabel,
  keyValue:"necesidad_cubierta",
  
  items: [
    {
      label: "Todas",
      value: -1,
    },
    {
      label: "Pendiente",
      value: 0,
    },
  {
    label: "Cubierta",
    value: 1
  },
    
  
  ],
  inputProps:{
    placeholder:'Todas'
  },
  InputComponentProps:{
    label:"Estado",
    fullWidth:true,
    isLoading:false,
    size:'small',
    value:true
    //onInputChange:searchMunicipiosOrigen,
   
  }
}
];




return (<>


  <Grid container spacing={2} alignItems="flex-end">
        <Grid item xs={12} sm={9} md={9} >
          <FilterForm
            buttomDist={
              {
                xs:12,
                sm:3,
                md:3
              }
            }
            nameFilter={"Buscar necesidades por"}
            inputsFilter={InputFilters}
            schemaValidator={schemaFilter}
            initialValuesFilter={
            {  product_select:filterNecesidades?.producto,
              fecha_entrega:filterNecesidades?.fecha,
              necesidad_cubierta:filterNecesidades?.necesidad_cubierta
             
             }
            }
            onApplyFilter={setFilterAply}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={3} >
         <TextField 
         onChange={e=>setTableSize(e.target.value)}
         type="number"
        value={tableSize}
         InputProps={{
          endAdornment:<IconButton onClick={saveScreenSize} aria-label="Guardar tamaño de tabla"><Save /></IconButton>
         }} variant="outlined" size="small" fullWidth label="Tamaño de la tabla" />
        </Grid>
   
    <Grid item sm={12} xs={12} md={12} >

    {/*   <TableContainer sx={{ maxHeight: window.screen.height * 0.60 }} > */}
    {/* <TableContainer sx={{ maxHeight:window.outerWidth * 0.60}} > */}
    <TableContainer sx={{ maxHeight:tableSize+'px'}} >
        <Table style={{borderColor:"gray"}} border={1} stickyHeader >
          <TableHead>
            <TableRow>

              {
                columnsTable.map(colum => <TableCell key={colum.key} >
                  {<colum.headerRender  {...colum}   />}
                </TableCell>)
              }

            </TableRow>

          </TableHead>
          <TableBody>

            {NewDataMapped.map(prod =>
              <TableRow key={prod.cod_producto+"-"+prod.conversion_unidad_medida}  >

                {
                  columnsTable.map(Col =>
                    <TableCell key={Col.key + "-" + prod.cod_producto+"-"+prod.conversion_unidad_medida} >
                      {<Col.bodyRender item={{...prod}} value={prod[Col.keyValue]} />}
                    </TableCell>)
                }

              </TableRow>
            )}

          </TableBody>

        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 40, 60]}
        component="div"
        count={totalRows}
        rowsPerPage={filterNecesidades?.rows_per_page}
        page={filterNecesidades?.page_number}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

    </Grid>
  </Grid>
</>)

}